import {Badge} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../app/hooks";
import {ChatEngine} from "../../../types";
import IconSparkles from "../../../assets/sparkles.svg?react";
import {Feature, useFeature} from "../../../featureFlags/featureFlags";

export function ExperimentalEngineIndicator() {
    const {t} = useTranslation();
    const chatEngine = useAppSelector((state) => state.session.chosenChatEngine);
    const {enabled: internalFeaturesEnabled} = useFeature(
        Feature.InternalFeatures
    );
    const {enabled: showDebugIndicators} = useFeature(
        Feature.DebugIndicators
    );

    if (!internalFeaturesEnabled || chatEngine !== ChatEngine.Experimental) {
        return null;
    }

    return (
        <Badge
            leftSection={<IconSparkles width={14} height={14} />}
            variant="light"
            color="grape"
            size="sm"
            style={
                showDebugIndicators
                    ? {
                          outline: "2px dashed var(--mantine-color-grape-5)",
                          outlineOffset: "2px",
                      }
                    : undefined
            }
        >
            {t("chat.experimentalEngineActive")}
        </Badge>
    );
}
